import PROJECTS from "./Projects";
import USER_MANAGEMENT from "./UserManegement";

const SHARED = {
    PROJECTS,
    USER_MANAGEMENT,
};
export default SHARED;
